import { useMemo } from "react";

import { DataGrid, getColumnsWithMultiLan, getRowsWithIndex } from "components";
import ErrorCode from "configs/errorCode";
import { CommonDialog } from "pages/Components";
import { RunPayrollDiffNoOfDependentEmployee } from "services";
import { useDialog } from "stores/Dialog";
import { getLanContent } from "utils";

export type Employee = {
  id?: string | number;
  code?: string;
  fullName?: string;
  title?: string;
  department?: string;
  message?: string;
};

const EmployeeErrorDialog: React.FC = () => {
  const employeesDialog = useDialog<{
    data?: RunPayrollDiffNoOfDependentEmployee[];
  }>({
    name: "ListEmployeeErrorDialog",
  });

  const rows = useMemo(
    () => getRowsWithIndex(employeesDialog?.dialog?.data?.data || []),
    [employeesDialog?.dialog?.data]
  );

  const columns = useMemo(
    () =>
      getColumnsWithMultiLan<Employee>([
        {
          field: "rowId",
          headerName: "Row ID",
          minWidth: 150,
          flex: 1,
        },
        {
          field: "code",
          headerName: "code",
          minWidth: 150,
          flex: 1,
        },
        {
          field: "fullName",
          headerName: "employeeName",
          flex: 1,
          minWidth: 150,
        },
        {
          field: "message",
          headerName: "errorContent",
          minWidth: 300,
          flex: 1,
          valueGetter: ({ value }) => {
            if (ErrorCode[value as never]) {
              return (
                (getLanContent(
                  ErrorCode[value as never],
                  "description"
                ) as never) || ""
              );
            }
            return (value as never) || "";
          },
        },
      ]),
    []
  );

  if (!employeesDialog.dialog.show) return <div />;

  return (
    <CommonDialog
      titleI18n="errorList"
      name="ListEmployeeErrorDialog"
      width={900}
    >
      <DataGrid
        containerHeight={400}
        columns={columns}
        rows={rows}
        rowCount={rows?.length || 0}
        pagination={false}
      />
    </CommonDialog>
  );
};

export default EmployeeErrorDialog;
